import React from 'react';
import {
  MINIMUM_CATS_SHOWN_COUNT,
  checkIfCategoryIsSelected,
  limitVisibility,
} from './categoriesUtils';
import { Item, Toggler } from './CategoriesLib';
import { CategoryType } from '../../../search.types';

type Props = {
  children: (cat: CategoryType) => React.ReactNode;
  items: CategoryType[];
  panes: {
    [s: string]: boolean;
  };
  aggregationsPaths: string[];
  path: Array<string>;
  handleClick: Function;
  togglePane: Function;
  customClass?: string;
  level: number;
};

export class CategoriesNode extends React.Component<Props> {
  static defaultProps = {
    items: [],
    children: () => null,
  };

  render() {
    const {
      children,
      items,
      panes,
      aggregationsPaths,
      path,
      handleClick,
      togglePane,
      customClass,
      level,
    } = this.props;
    const key = path[path.length - 1];
    return (
      <>
        {items.length > 0 && (
          <div className={customClass}>
            {items
              .filter(limitVisibility(panes, aggregationsPaths, path))
              .map(subCategory => (
                <Item
                  data-test-id={`category-node-${level}`}
                  key={subCategory.key}
                  handleClick={handleClick(path, subCategory)}
                  category={subCategory}
                  isSelected={checkIfCategoryIsSelected(
                    [...path, subCategory.key],
                    aggregationsPaths,
                  )}
                >
                  {children(subCategory)}
                </Item>
              ))}
            {items.length > MINIMUM_CATS_SHOWN_COUNT && (
              <Toggler onToggle={togglePane(path)} isOpen={panes[key]} />
            )}
          </div>
        )}
      </>
    );
  }
}
